import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ReportOPEEnum} from "./ReportOPEEnum";

class O {
}

class I {
  id!: number;
}

export class DelUserReportCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(ReportOPEEnum.DelUserReport);
    this.i = new I();
    this.o = new O();
  }
}
